// app/src/pages/PartResetPasswordPage.tsx
import React, { FC } from 'react';
import { useMediaQuery } from 'react-responsive';
import HeaderResponsivePart from '../components/responsive/HeaderResponsivePart';
import { useScaleMobile } from '../contexts/ScaleContextMobile';
import { useScaleDesktop } from '../contexts/ScaleContextDesktop';
import ResetPasswordDesktopPart from '../components/desktop/part/ResetPasswordDesktopPart';
import ResetPasswordMobilePart from '../components/mobile/part/ResetPasswordMobilePart';

const PartResetPasswordPage: FC = () => {
  const { scaleMobile } = useScaleMobile();
  const { scaleDesktop } = useScaleDesktop();

  const isDesktop = useMediaQuery({ query: '(min-width: 768px)' });

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'start',
        alignItems: 'center',
      }}
    >
      <HeaderResponsivePart />
      {isDesktop ? (
        <div
          style={{
            position: 'absolute',
            top: 90,
            transform: `scale(${scaleDesktop})`,
            color: '#323E48',
            transformOrigin: 'top',
            transition: 'transform 0.3s ease, padding 0.3s ease',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <ResetPasswordDesktopPart />
        </div>
      ) : (
        <div
          style={{
            color: '#323E48',
            width: 390,
            transform: `scale(${scaleMobile})`,
            transformOrigin: 'top',
            transition: 'transform 0.3s ease, padding 0.3s ease',
            overflow: 'auto',
          }}
        >
          <ResetPasswordMobilePart />
        </div>
      )}
    </div>
  );
};

export default PartResetPasswordPage;
